// ISO country-code → human name, so the UI never shows a cryptic 2-letter code.
export const COUNTRY_NAMES = {
  US: "United States", GB: "United Kingdom", IN: "India", DE: "Germany",
  FR: "France", CA: "Canada", AU: "Australia", BR: "Brazil", NL: "Netherlands",
  SG: "Singapore", ES: "Spain", SE: "Sweden", AE: "UAE", JP: "Japan",
  PL: "Poland", IL: "Israel", IT: "Italy", PT: "Portugal", CH: "Switzerland",
  IE: "Ireland", NO: "Norway", DK: "Denmark", FI: "Finland", BE: "Belgium",
  AT: "Austria", NZ: "New Zealand", ZA: "South Africa", MX: "Mexico",
  AR: "Argentina", NG: "Nigeria", ID: "Indonesia", PH: "Philippines",
  VN: "Vietnam", TR: "Turkey", UA: "Ukraine", KR: "South Korea", CN: "China",
  HK: "Hong Kong", TW: "Taiwan", MY: "Malaysia", TH: "Thailand", EG: "Egypt",
  SA: "Saudi Arabia", CZ: "Czechia", RO: "Romania", GR: "Greece", CL: "Chile",
};

export const countryName = (code) => (code ? (COUNTRY_NAMES[code] || code) : "");
